import { HttpClient } from '@angular/common/http';
import { Injectable} from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class INDRAIbeAdminMktService {

	constructor(
		private http: HttpClient
	) {}

	sendEmail(campaignId: string, emailTo: string, params: any): Observable<any> {
		return this.http
			.post<any>(`${environment.api_url}/ibe/admin/mkt/campaigns/${campaignId}/launchWithParams?destination=${emailTo}`, params);
	}
}
